import React from "react"
import FieldTags from "../tags";
import {FieldViewPropertyProps} from "../../../render/view-property";
import {ColorPalette} from "../../../color-coding/color-coding";

export default function FieldTag_ViewProperty(props: FieldViewPropertyProps) {
    const field = props.field as any as FieldTags
    const value = field.getViewValue(props.model)

    if (_.isEmpty(value)) return null // value = array (!)

    const valueOptions   = field._getOptions(value)

    if (!valueOptions) return null

    return (
        <>
            {_.map(valueOptions, (option, key) => {

                const style = {
                        backgroundColor : gd.skin.colors.paleBGColor({
                        colorNumber     : option.color,
                        corePalette     : ColorPalette.CORE
                    }),
                }

                const iconStyle = {
                        color       : gd.skin.colors.mainColor({
                        colorNumber : option.color,
                        corePalette : ColorPalette.CORE
                    })
                }

                return (
                    <div key        = {key}
                         className  = "gd-tag-tile fs-12 size-22 m-r-5 m-b-5"
                         style      = {style}>

                        <div className  = "i5-tag-solid"
                             style      = {iconStyle}/>

                        {option.label}

                    </div>
                )
            })}
        </>

    )
}
